import { type EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { forkJoin, map } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

export function appInitializerPreloadScopes(...scopes: string[]): EnvironmentProviders {
  return provideAppInitializer(() => {
    const translocoService = inject(TranslocoService);

    return forkJoin(
      scopes.map(scope => translocoService.load(translocoService._completeScopeWithLang(scope))),
    ).pipe(map(() => true));
  });
}
